import Options from '../../Options.esm.js';

var spatialMatcher = (match => {
  let warning = Options.translations.warnings.keyPattern;

  if (match.turns === 1) {
    warning = Options.translations.warnings.straightRow;
  }

  return {
    warning,
    suggestions: [Options.translations.suggestions.longerKeyboardPattern]
  };
});

export { spatialMatcher as default };
//# sourceMappingURL=feedback.esm.js.map
